import { render, staticRenderFns } from "./TopAdminsCard.vue?vue&type=template&id=b732c7f2&"
import script from "./TopAdminsCard.vue?vue&type=script&lang=js&"
export * from "./TopAdminsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports